import { render } from "./ListeTaxePage.vue?vue&type=template&id=53892395&ts=true"
import script from "./ListeTaxePage.vue?vue&type=script&lang=ts"
export * from "./ListeTaxePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__